var map = {
	"./Module/employee.module": [
		"./src/app/Module/employee.module.ts",
		"Module-employee-module"
	],
	"./Module/events.module": [
		"./src/app/Module/events.module.ts",
		"Module-events-module"
	],
	"./Module/front-desk.module": [
		"./src/app/Module/front-desk.module.ts",
		"Module-front-desk-module"
	],
	"./Module/hostel.module": [
		"./src/app/Module/hostel.module.ts",
		"Module-hostel-module"
	],
	"./Module/lab.module": [
		"./src/app/Module/lab.module.ts",
		"Module-lab-module"
	],
	"./Module/library.module": [
		"./src/app/Module/library.module.ts",
		"Module-library-module"
	],
	"./Module/master.module": [
		"./src/app/Module/master.module.ts",
		"common",
		"Module-master-module"
	],
	"./Module/report.module": [
		"./src/app/Module/report.module.ts",
		"Module-report-module~Module-result-module",
		"common",
		"Module-report-module"
	],
	"./Module/result.module": [
		"./src/app/Module/result.module.ts",
		"Module-report-module~Module-result-module",
		"common",
		"Module-result-module"
	],
	"./Module/store.module": [
		"./src/app/Module/store.module.ts",
		"Module-store-module"
	],
	"./Module/student.module": [
		"./src/app/Module/student.module.ts",
		"Module-student-module"
	],
	"./Module/transport.module": [
		"./src/app/Module/transport.module.ts",
		"common",
		"Module-transport-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;